export const ENGAGEMENT_GLOSSARY = [
  {
    key: 'engagement.dau',
    label: 'DAU (ativos no dia)',
    whatIs: 'DAU (Daily Active Users, ativos no dia): pessoas diferentes que concluíram pelo menos uma ação de uso real no dia, como bater ponto, pedir ou aprovar ajuste, férias ou espelho. Na série semanal ou mensal, é a média diária.',
    purpose: 'Mede o volume diário de uso. Comparado com o MAU mostra o hábito (DAU/MAU); comparado com "Em uso no dia" mostra quem abriu o sistema e não agiu.',
    howGenerated: 'Eventos de uso coletados a cada 15 minutos e somados por dia local da empresa no fechamento diário (00:30, horário de Brasília). Contam funcionário, gestor, admin e contador de empresas do universo ativo.',
    caveat: 'A mesma pessoa em duas empresas conta uma vez no total. Só abrir o sistema não conta como ativo.',
    metricKey: 'dau',
    seeAlso: ['engagement.mau', 'engagement.inUseDay'],
  },
  {
    key: 'engagement.wau',
    label: 'WAU (ativos em 7 dias)',
    whatIs: 'WAU (Weekly Active Users, ativos na semana): pessoas diferentes ativas pelo menos uma vez nos 7 dias que terminam no dia de referência. É uma janela móvel, não a semana do calendário.',
    purpose: 'Mostra o alcance semanal: quem usa toda semana, mesmo sem usar todo dia.',
    howGenerated: 'Calculado no fechamento diário a partir dos eventos de uso real, com a mesma regra e a mesma base do DAU. Na série semanal ou mensal, vale o último dia do intervalo; na Visão geral, o último dia fechado do período.',
    caveat: 'Se a janela começa antes do início da coleta, o número sai "Parcial" (janela incompleta).',
    metricKey: 'wau',
  },
  {
    key: 'engagement.mau',
    label: 'MAU (ativos em 30 dias)',
    whatIs: 'MAU (Monthly Active Users, ativos no mês): pessoas diferentes ativas pelo menos uma vez nos 30 dias que terminam no dia de referência. É uma janela móvel, não o mês do calendário.',
    purpose: 'É a base de usuários que de fato usam o produto: denominador do hábito (DAU/MAU) e da concentração das 10 maiores empresas.',
    howGenerated: 'Calculado no fechamento diário a partir dos eventos de uso real. Na série semanal ou mensal, vale o último dia do intervalo; na Visão geral, o último dia fechado do período.',
    caveat: 'Se a janela começa antes do início da coleta, o número sai "Parcial" (janela incompleta).',
    metricKey: 'mau',
  },
  {
    key: 'engagement.stickiness',
    label: 'DAU/MAU',
    whatIs: 'Parte de quem foi ativo nos 30 dias que usou no dia: DAU ÷ MAU × 100. Também chamado de stickiness, ou hábito.',
    purpose: 'Mede o hábito: 40% quer dizer que, em média, 4 de cada 10 ativos do mês usam num dia; queda com MAU estável indica gente que usa menos vezes.',
    howGenerated: 'Conta feita em cada ponto da série. Na série semanal ou mensal, o DAU é a média diária do intervalo e o MAU é o do último dia dele.',
    caveat: 'A Visão geral usa a média do DAU ÷ a média do MAU do período, então os dois números não precisam bater.',
    metricKey: 'stickiness',
    seeAlso: ['engagement.wauMau'],
  },
  {
    key: 'engagement.wauMau',
    label: 'WAU/MAU',
    whatIs: 'Parte de quem foi ativo nos 30 dias que também usou nos últimos 7 dias: WAU ÷ MAU × 100, no mesmo dia.',
    purpose: 'Mostra o uso semanal: perto de 100% quer dizer que quase todo ativo do mês voltou na última semana; queda indica gente que parou de usar.',
    howGenerated: 'Conta feita pelo Master com o WAU e o MAU do mesmo ponto da série, ambos do fechamento diário.',
    caveat: 'Sai n/d quando o MAU do ponto é zero ou não existe.',
    seeAlso: ['engagement.stickiness'],
  },
  {
    key: 'engagement.inUseDay',
    label: 'Em uso no dia',
    whatIs: 'Pessoas diferentes com qualquer sinal no dia: abriram o sistema, consultaram uma tela ou tentaram uma ação, mesmo sem concluir. Todo ativo também está em uso.',
    purpose: 'A distância para o DAU mostra quem aparece e não age: sinal de dúvida, de tela que não resolve ou de acesso só para consulta.',
    howGenerated: 'Eventos coletados a cada 15 minutos, somados por dia local da empresa no fechamento diário. O login automático do tablet MarQTab, a cada 15 minutos, não conta.',
    caveat: 'A abertura da V2 no navegador só conta a partir do dia em que a sessão da V2 passou a ser coletada.',
    metricKey: 'in_use',
    seeAlso: ['engagement.dau', 'engagement.openedWithoutAction'],
  },
  {
    key: 'engagement.inUseWeek',
    label: 'Em uso em 7 dias',
    whatIs: 'Pessoas diferentes com qualquer sinal (abrir o sistema, consultar ou tentar uma ação) nos 7 dias que terminam no dia de referência.',
    purpose: 'Comparado com o WAU, mostra quanta gente aparece na semana sem concluir nenhuma ação de uso real.',
    howGenerated: 'Janela móvel de 7 dias calculada no fechamento diário, com a mesma regra do "Em uso no dia". Na série semanal ou mensal, vale o último dia do intervalo.',
    metricKey: 'in_use',
    seeAlso: ['engagement.wau'],
  },
  {
    key: 'engagement.inUse',
    label: 'Em uso (30 dias)',
    whatIs: 'Pessoas diferentes com qualquer sinal (abrir o sistema, consultar ou tentar uma ação) nos 30 dias que terminam no dia de referência.',
    purpose: 'Comparado com o MAU, mostra quanta gente abre o sistema no mês sem concluir nenhuma ação de uso real.',
    howGenerated: 'Janela móvel de 30 dias calculada no fechamento diário, sem o login automático do tablet MarQTab. Na série semanal ou mensal, vale o último dia do intervalo; nas listas, o último dia fechado do período.',
    metricKey: 'in_use',
    seeAlso: ['engagement.mau', 'engagement.openedWithoutAction'],
  },
  {
    key: 'engagement.openedWithoutAction',
    label: 'Abriram sem agir',
    whatIs: 'Pessoas em uso nos 30 dias que não concluíram nenhuma ação de uso real: em uso (30 dias) menos ativos (30 dias).',
    purpose: 'Aponta onde o produto é aberto e não resolve: grupo alto pede olhar a tela, o treinamento ou a permissão de quem só consulta.',
    howGenerated: 'Subtração dos dois números do mesmo dia de referência, calculados no fechamento diário na janela de 30 dias.',
    caveat: 'Quem só consulta (como o funcionário que lê o espelho) é esperado aqui e não indica problema.',
    seeAlso: ['engagement.inUse', 'engagement.mau'],
  },
  {
    key: 'engagement.activeCompaniesDay',
    label: 'Empresas ativas no dia',
    whatIs: 'Empresas do universo ativo com pelo menos uma pessoa ativa (ação de uso real) no dia.',
    purpose: 'Mostra quantas contas usam o produto num dia comum; dias úteis e fins de semana ficam visíveis na curva.',
    howGenerated: 'Calculado no fechamento diário a partir dos eventos de uso real, por dia local da empresa. Na série semanal ou mensal, vale o último dia do intervalo.',
    metricKey: 'active_companies',
  },
  {
    key: 'engagement.activeCompaniesWeek',
    label: 'Empresas ativas em 7 dias',
    whatIs: 'Empresas do universo ativo com pelo menos uma pessoa ativa nos 7 dias que terminam no dia de referência.',
    purpose: 'Mostra quantas contas usaram na semana, sem o efeito de fim de semana e feriado da curva diária.',
    howGenerated: 'Janela móvel de 7 dias calculada no fechamento diário a partir dos eventos de uso real.',
    metricKey: 'active_companies',
  },
  {
    key: 'engagement.activeCompaniesMonth',
    label: 'Empresas ativas (30 dias)',
    whatIs: 'Empresas do universo ativo com pelo menos uma pessoa que concluiu ação de uso real nos 30 dias que terminam no dia de referência. Na Visão geral, "Empresas com uso real".',
    purpose: 'Conta as contas vivas: empresa ativa no cadastro em que ninguém agiu fica fora, mesmo que alguém tenha só aberto o sistema.',
    howGenerated: 'Janela móvel de 30 dias calculada no fechamento diário. Na série semanal ou mensal, vale o último dia do intervalo; na Visão geral, o último dia fechado do período.',
    caveat: 'Empresa de demonstração nunca entra.',
    metricKey: 'active_companies',
    seeAlso: ['common.universe'],
  },
  {
    key: 'engagement.pointDate',
    label: 'Data do ponto',
    whatIs: 'Dia que o ponto da série representa. Na série diária é o próprio dia; na semanal, a segunda-feira que abre a semana; na mensal, o primeiro dia do mês.',
    purpose: 'Identifica cada linha da série para cruzar com outros números ou com eventos do calendário, como feriados e campanhas.',
    howGenerated: 'Dia local da empresa. Na série semanal ou mensal, o DAU é a média dos dias do intervalo e os demais números são do último dia dele.',
    seeAlso: ['filter.granularity'],
  },
  {
    key: 'engagement.was',
    label: 'WAS (assentos em uso na semana)',
    whatIs: 'Parte dos usuários habilitados que esteve em uso nos 7 dias que terminam no dia de referência: abriu o sistema ou agiu. WAS vem de Weekly Active Seats, assentos ativos na semana.',
    purpose: 'Mostra quanto da base cadastrada aparece no sistema na semana; é mais amplo que o Active Seats Rate, que só conta quem agiu.',
    howGenerated: 'Habilitados em uso em 7 dias ÷ habilitados × 100, no último dia fechado do período, do fechamento diário. O login automático do tablet MarQTab não conta.',
    caveat: 'Com filtro de plataforma ou módulo, o denominador é o total de habilitados.',
    metricKey: 'was',
    seeAlso: ['common.activeSeatsRate'],
  },
  {
    key: 'engagement.activeEnabled',
    label: 'Ativos habilitados (30 dias)',
    whatIs: 'Usuários habilitados hoje que concluíram pelo menos uma ação de uso real nos 30 dias até o último dia fechado do período.',
    purpose: 'É o numerador do Active Seats Rate e da utilização do contrato.',
    howGenerated: 'Contado no fechamento diário, cruzando os ativos da janela de 30 dias com o cadastro de usuários habilitados.',
    seeAlso: ['common.activeSeatsRate', 'engagement.enabledEligible'],
  },
  {
    key: 'engagement.enabledEligible',
    label: 'Habilitados elegíveis',
    whatIs: 'Usuários ativos e não excluídos, com papel de funcionário, gestor, admin ou contador, em empresas do recorte. Com filtro de papel, só os daquele papel.',
    purpose: 'É o denominador do Active Seats Rate e do WAS: a base que poderia usar o produto.',
    howGenerated: 'Contados no retrato noturno do cadastro de usuários, no dia de referência (último dia fechado do período).',
    caveat: 'Não é o número de funcionários do cadastro da empresa, que só define o porte.',
    seeAlso: ['common.enabledUsers'],
  },
  {
    key: 'engagement.seatsContracted',
    label: 'Assentos contratados (total)',
    whatIs: 'Soma dos assentos (máximo de funcionários do contrato) das assinaturas ativas das empresas do recorte.',
    purpose: 'É o denominador da utilização do contrato: compara o uso com o que foi vendido.',
    howGenerated: 'Lido da assinatura ativa de cada empresa no retrato noturno dos bancos; só entram empresas com assinatura ativa.',
    caveat: 'Fica vazio com filtro de plataforma ou módulo, em que a utilização do contrato não se aplica.',
    seeAlso: ['common.contractUtilization'],
  },
  {
    key: 'engagement.seatsCut',
    label: 'Corte do Active Seats Rate',
    whatIs: 'Dimensão em que o Active Seats Rate foi aberto: por papel do usuário (perfil), por módulo ou por porte da empresa.',
    purpose: 'Mostra onde a base habilitada usa menos, para direcionar ativação a um papel, módulo ou faixa de empresa.',
    howGenerated: 'Os cortes saem do agregado diário de janela por segmento, no último dia fechado do período, e só são calculados sem filtros de empresa e de corte.',
    seeAlso: ['engagement.seatsCutRate'],
  },
  {
    key: 'engagement.seatsCutValue',
    label: 'Recorte',
    whatIs: 'Valor do corte na linha: o papel (Funcionário, Gestor, Admin, Contador), o módulo do catálogo ou o porte da empresa.',
    purpose: 'Identifica o grupo a que o Active Seats Rate da linha se refere.',
    howGenerated: 'Papel e porte vêm do retrato noturno de usuários e empresas; o módulo, do catálogo de eventos do PI.',
  },
  {
    key: 'engagement.seatsCutRate',
    label: 'Active Seats Rate por corte',
    whatIs: 'Ativos habilitados em 30 dias do grupo ÷ habilitados do grupo × 100. Por módulo, o numerador é quem agiu no módulo e o denominador é o total de habilitados.',
    purpose: 'Compara a taxa de uso entre papéis, módulos e portes com a mesma régua do total.',
    howGenerated: 'Do agregado diário de janela de 30 dias por segmento, no último dia fechado do período, cruzado com os habilitados do retrato noturno.',
    caveat: 'Sem comparação com o período anterior. Os cortes não aceitam filtros: com filtro de empresa ou de corte a tabela fica vazia.',
    metricKey: 'active_seats_rate',
    seeAlso: ['common.activeSeatsRate'],
  },
  {
    key: 'engagement.dimension',
    label: 'Dimensão da segmentação',
    whatIs: 'Escolhe como dividir as pessoas na tabela: papel do usuário (padrão), módulo, plataforma, porte ou perfil da empresa.',
    purpose: 'Mostra quem usa, quem só abre e quanto cada grupo pesa nos ativos, um corte por vez.',
    howGenerated: 'Cada opção lê o agregado diário de janela de 30 dias daquele segmento, no último dia fechado do período.',
    caveat: 'A segmentação só existe sem filtros de empresa e de corte; com eles, a tabela fica vazia e explica o motivo.',
  },
  {
    key: 'engagement.segmentRole',
    label: 'Papel do usuário (segmentação)',
    whatIs: 'Papel da pessoa no cadastro: Funcionário, Gestor (funcionário responsável por equipe), Admin ou Contador.',
    purpose: 'Compara o uso de quem bate ponto com o de quem aprova e administra.',
    howGenerated: 'O papel vem do retrato diário de usuários; cada pessoa entra no papel que tinha no dia da ação.',
    caveat: 'A mesma pessoa pode aparecer em mais de um papel ao longo da janela, então a soma das linhas pode passar do total.',
  },
  {
    key: 'engagement.segmentModule',
    label: 'Módulo (segmentação)',
    whatIs: 'Área do catálogo de eventos do produto em que a pessoa agiu, como Controle de Jornada ou Departamento Pessoal.',
    purpose: 'Mostra quais módulos concentram uso real e quais são só abertos.',
    howGenerated: 'A pessoa conta no módulo em que teve pelo menos um evento na janela de 30 dias, segundo o catálogo de eventos.',
    caveat: 'Quem usa vários módulos conta em cada um, então a soma passa do total.',
  },
  {
    key: 'engagement.segmentPlatform',
    label: 'Plataforma (segmentação)',
    whatIs: 'Canal pelo qual a pessoa usou: Web, Web V2, app, tablet, QR Code, reconhecimento facial, API pública, relógio de ponto e outros.',
    purpose: 'Mede a migração entre canais, como do painel antigo para a Web V2 ou do relógio de ponto para o app.',
    howGenerated: 'O canal vem de quem gravou o evento (aplicativo, tela ou integração); a pessoa conta em cada canal que usou na janela de 30 dias.',
    caveat: 'Linhas com * têm quebra de série; leia a nota abaixo da tabela antes de comparar períodos.',
  },
  {
    key: 'engagement.segmentActive',
    label: 'Ativos do segmento',
    whatIs: 'Pessoas do grupo que concluíram pelo menos uma ação de uso real nos 30 dias que terminam no último dia fechado do período.',
    purpose: 'Mostra o tamanho do uso real em cada grupo.',
    howGenerated: 'Do agregado diário de janela de 30 dias por segmento, calculado no fechamento diário. Com "Comparar", a variação é contra o mesmo número no fim do período anterior.',
    metricKey: 'mau',
  },
  {
    key: 'engagement.segmentInUse',
    label: 'Em uso do segmento',
    whatIs: 'Pessoas do grupo com qualquer sinal (abrir o sistema, consultar ou tentar uma ação) nos 30 dias que terminam no último dia fechado do período.',
    purpose: 'Comparado com os ativos do grupo, mostra quem aparece sem agir.',
    howGenerated: 'Do agregado diário de janela de 30 dias por segmento, sem o login automático do tablet MarQTab.',
    metricKey: 'in_use',
  },
  {
    key: 'engagement.segmentShare',
    label: 'Participação nos ativos',
    whatIs: 'Ativos do grupo ÷ ativos de todo o recorte (MAU) × 100, no mesmo dia de referência.',
    purpose: 'Mostra quanto do uso real vem de cada grupo.',
    howGenerated: 'Conta feita pela API com os ativos em 30 dias do grupo e do total, ambos do agregado diário de janela.',
    caveat: 'A mesma pessoa pode estar em vários grupos (módulos, plataformas), então a soma pode passar de 100%.',
  },
  {
    key: 'engagement.segmentNote',
    label: 'Nota do segmento',
    whatIs: 'Aviso de quebra de série em algumas plataformas, como Web, Web V2 e Desconhecida, por mudança na forma de reconhecer o canal.',
    purpose: 'Evita ler como mudança de uso o que foi mudança de medição.',
    howGenerated: 'Texto fixo do PI com a data em que o reconhecimento do canal mudou; aparece como * ao lado do nome na tela.',
  },
  {
    key: 'engagement.distributionBand',
    label: 'Faixa de usuários ativos (30 dias)',
    whatIs: 'Faixa da empresa pelo número de ativos em 30 dias: sem ativos, 1 a 5, 6 a 20, 21 a 50, 51 a 200 e mais de 200.',
    purpose: 'Mostra como as contas se distribuem por tamanho de uso real; clicar numa faixa filtra a lista de empresas.',
    howGenerated: 'Do agregado por empresa na janela de 30 dias que termina no último dia fechado do período; empresa fora do universo ativo não entra em nenhuma faixa.',
    seeAlso: ['filter.band'],
  },
  {
    key: 'engagement.distributionCompanies',
    label: 'Empresas na faixa',
    whatIs: 'Quantas empresas do recorte têm o número de ativos em 30 dias dentro da faixa.',
    purpose: 'Dá o tamanho de cada faixa, por exemplo quantas contas estão sem nenhum ativo.',
    howGenerated: 'Contagem feita pela API sobre a mesma lista de empresas, com busca, jornada, contrato e queda aplicados, mas sem o filtro de faixa.',
  },
  {
    key: 'engagement.distributionShare',
    label: 'Empresas na faixa (% do total)',
    whatIs: 'Empresas da faixa ÷ empresas de todas as faixas × 100.',
    purpose: 'Compara o peso das faixas entre períodos e recortes de tamanhos diferentes.',
    howGenerated: 'Conta feita pelo Master com as contagens de cada faixa devolvidas pela API.',
  },
  {
    key: 'engagement.companyInUse',
    label: 'Em uso da empresa (30 dias)',
    whatIs: 'Pessoas da empresa com qualquer sinal (abrir o sistema, consultar ou tentar uma ação) nos 30 dias que terminam no último dia fechado do período.',
    purpose: 'Comparado com os ativos da empresa, mostra quem abre o sistema e não agiu.',
    howGenerated: 'Do agregado por empresa na janela de 30 dias, calculado no fechamento diário.',
    seeAlso: ['common.activeUsers30d'],
  },
];



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/glossary/engagement.js